import { LeadNote } from "./LeadNote";
import { LeadPermission } from "./LeadPermission";
import { ChannelMetadataType } from "../campaigns/ChannelMetadataType";

export interface ContactForm {
  ID: number;
  AdditionalStatusId?: number;
  AssetId: string;
  AssigneeID?: number;
  CallID: string;
  ChannelID: number;
  ClientID: number;
  GoogleKeywordId: number;
  LeadApiTypeID: number;
  LeadClientID: number;
  LeadEntryStatusID: number;
  LeadStatusID: number;
  ProjectPerformanceId?: number;

  AdCampaignIdExternal: string;
  AdCampaignNameExternal: string;
  AdGroupIdExternal: string;
  AdGroupNameExternal: string;
  AdIdExternal: string;
  AdNameExternal: string;
  AdditionalStatus: string;
  Address: string;
  Amount: number;
  AssetTitle: string;
  AssigneeName: string;
  CallSeconds: number;
  CallSecondsStr: string;
  CallStatus: string;
  CampaignTitle: string;
  ChannelMetadataType: ChannelMetadataType;
  ChannelMetadataTypeText: string;
  ChannelTitle: string;
  Client: string;
  CreateDate: Date;
  CreditCardProblem?: boolean;
  Data: string;
  DealStr: string;
  Deleted: boolean;
  Email: string;
  Favourite: boolean;
  FormUrl: string;
  FoundMetadataType: ChannelMetadataType;
  FoundMetadataTypeText: string;
  FullName: string;
  IsBad: boolean;
  IsBadUpdateDate?: Date;
  IsCalculatedLead: boolean;
  IsClosed: boolean;
  IsClosedUpdateDate?: Date;
  IsInProcess: boolean;
  IsInProcessUpdateDate?: Date;
  IsSentToCrm: boolean;
  IsUnique: boolean;
  JsonData: string;
  Keyword: string;
  LeadApiTypeText: string;
  LeadEntryStatus: string;
  Meeting: boolean;
  MeetingStartDate?: Date;
  MeetingStatus: string;
  MeetingStr: string;
  MeetingUpdateDate?: Date;
  Note: string;
  Phone: string;
  Price: number;
  ProjectPerformanceTitle: string;
  SaleStatus: string;
  SaleStatusStr: string;
  Status: string;
  StatusCall?: number;
  Tag: string;
  ToPhone: string;
  UrlReferer: string | null;
  UserIp: string;
}

export interface LeadClientEditViewModel {
  EditAllLeads: boolean;
  IsLeadViewer: boolean;
  IsShared: boolean;
  ShowDealsAmount: boolean;
  ShowEmail: boolean;
  ShowFullname: boolean;
  ShowOtherData: boolean;
  ShowPhone: boolean;
  ShowPrice: boolean;
  ShowSalesman: boolean;
  LeadClient: ContactForm;
  ActiveRestictions: LeadPermission[];
  LeadNotes: LeadNote[];
}

export interface LeadEditViewModel {
  EditAllLeads: boolean;
  IsLeadViewer: boolean;
  IsShared: boolean;
  ShowDealsAmount: boolean;
  ShowEmail: boolean;
  ShowFullname: boolean;
  ShowOtherData: boolean;
  ShowPhone: boolean;
  ShowPrice: boolean;
  ShowSalesman: boolean;
  ContactForm: ContactForm;
  ActiveRestictions: LeadPermission[];
  LeadNotes: LeadNote[];
}

export interface LeadsPageViewModel {
  ClientId: number;
  CanDeleteLeads: boolean;
  EditAllLeads: boolean;
  ShowAllLeads: boolean;
  ShowDealsAmount: boolean;
  ShowEmail: boolean;
  ShowFullname: boolean;
  ShowOtherData: boolean;
  ShowPhone: boolean;
  ShowPrice: boolean;
  ShowSalesman: boolean;
  ActiveRestictions: LeadPermission[];
}

export interface UpdateLeadResponse {
  message: string;
  success: boolean;
  status: string;
}

export enum RefreshGridMode {
  None,
  Full,
  GraphsOnly,
  GridOnly
}

export enum ToggleLeadEditMode {
  None,
  Notes
}

export interface PhonePopupData {
    showPopup: boolean;
    message?: string;
}